@if (isMobile()) {
  <nav class="bottom-nav">
    <a
      class="bottom-nav__item"
      routerLink="/home"
      routerLinkActive="bottom-nav__item--active"
      [routerLinkActiveOptions]="{ exact: true }"
      matRipple
    >
      <mat-icon class="bottom-nav__icon">home</mat-icon>
      <span class="bottom-nav__label">Home</span>
    </a>

    <button
      class="bottom-nav__item"
      (click)="openSectorPicker()"
      matRipple
    >
      <mat-icon class="bottom-nav__icon">explore</mat-icon>
      <span class="bottom-nav__label">Settori</span>
    </button>

    <a
      class="bottom-nav__item"
      routerLink="/settings"
      routerLinkActive="bottom-nav__item--active"
      matRipple
    >
      <mat-icon class="bottom-nav__icon">settings</mat-icon>
      <span class="bottom-nav__label">Impostazioni</span>
    </a>

    <a
      class="bottom-nav__item"
      [routerLink]="profileLink()"
      routerLinkActive="bottom-nav__item--active"
      matRipple
    >
      <mat-icon class="bottom-nav__icon">person</mat-icon>
      <span class="bottom-nav__label">{{ profileLabel() }}</span>
    </a>
  </nav>
}
